// Phase 6 — Track E T-E3. IconButton primitive (hand-rolled).
//
// A square button that holds a single icon. Mandatory aria-label so the
// button has an accessible name when no visible text is present.
// Wraps Button(size='icon').

import * as React from 'react';
import { Button, type ButtonProps } from './Button.js';
import { cn } from '../../lib/cn.js';

export interface IconButtonProps extends Omit<ButtonProps, 'size' | 'children'> {
  'aria-label': string;
  children: React.ReactNode;
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ className, variant = 'ghost', children, ...props }, ref) => (
    <Button
      ref={ref}
      variant={variant}
      size="icon"
      className={cn('rounded-md', className)}
      {...props}
    >
      {children}
    </Button>
  ),
);
IconButton.displayName = 'IconButton';
